import { useState, useEffect ,useRef} from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';

function Assets () {

      const [search, setSearch] = useState("");
        const [showForm, setShowForm] = useState(false);

         const [formItems, setFormItems] = useState({
  asset_description:'',
  category:'',
  status:'',
  department:'',
  employee:'',
  make:'',
  vendor:'',
  model:'',
  sr_no:'',
  date_acquired:'',
  purchase_price:'',
  current_value:'',
  barcode_no:'',
  next_date:'',
  life:'',
  description:'',
  date_sold:'',
  sevage_value:'',
  comments:'',
  })

          const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
    const [searchTerm, setSearchTerm] = useState('');
     const [isEditMode, setIsEditMode] = useState(false);


  const handleAddClick = () => {
    setShowForm(true);
  }

 const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const resetForm = () => {

  }

    return (
        <>
  <div className='main-section'>
       <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />

          <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
         <h3 className='my-3 fw-bold fs-5 golos'>Assets</h3>
           <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
            <div class="col-12 col-md-4">
              <input
                type="text"
                class="form-control"
                id="searchInput"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-end">
              <button className='btn btn-success' onClick={handleAddClick} >
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>

            {showForm && ( 

                <form >
 <div className='card p-3 my-3 shadow-sm bg-white border'>
    
    <div className='row g-3'>
           <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Assest Description </label>
                        <input
                          type="text"
                          className="form-control"
                          name="asset_description"
                          value={formItems.asset_description}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Category</label>
                        <input
                          type="text"
                          className="form-control"
                          name="category"
                          value={formItems.category}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Status </label>
                        <input
                          type="text"
                          className="form-control"
                          name="status"
                          value={formItems.status}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Department</label>
                        <input
                          type="text"
                          className="form-control"
                          name="department"
                          value={formItems.department}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Employee </label>
                        <input
                          type="text"
                          className="form-control"
                          name="employee"
                          value={formItems.employee}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Make</label>
                        <input
                          type="text"
                          className="form-control"
                          name="make"
                          value={formItems.make}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Vendor </label>
                        <input
                          type="text"
                          className="form-control"
                          name="vendor"
                          value={formItems.vendor}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Model</label>
                        <input
                          type="text"
                          className="form-control"
                          name="model"
                          value={formItems.model}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Serial No </label>
                        <input
                          type="text"
                          className="form-control"
                          name="sr_no"
                          value={formItems.sr_no}
                          onChange={handleChange}
                        />
                      </div>


                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Date Acquired </label>
                        <input
                          type="text"
                          className="form-control"
                          name="date_acquired"
                          value={formItems.date_acquired}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Purchase Price</label>
                        <input
                          type="text"
                          className="form-control"
                          name="purchase_price"
                          value={formItems.purchase_price}
                          onChange={handleChange}
                        />
                      </div>


                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Current Value </label>
                        <input
                          type="text"
                          className="form-control"
                          name="current_value"
                          value={formItems.current_value}
                          onChange={handleChange}
                        />
                      </div>


                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Barcode Number </label>
                        <input
                          type="text"
                          className="form-control"
                          name="barcode_no"
                          value={formItems.barcode_no}
                          onChange={handleChange}
                        />
                      </div>


                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Next Date </label>
                        <input
                          type="text"
                          className="form-control"
                          name="next_date"
                          value={formItems.next_date}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Life </label>
                        <input
                          type="text"
                          className="form-control"
                          name="life"
                          value={formItems.life}
                          onChange={handleChange}
                        />
                      </div>

                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Description</label>
                        <input
                          type="text"
                          className="form-control"
                          name="description"
                          value={formItems.description}
                          onChange={handleChange}
                        />
                      </div>


                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium"> Date Sold </label>
                        <input
                          type="text"
                          className="form-control"
                          name="date_sold"
                          value={formItems.date_sold}
                          onChange={handleChange}
                        />
                      </div>


                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Savage Value </label>
                        <input
                          type="text"
                          className="form-control"
                          name=" sevage_value"
                          value={formItems. sevage_value}
                          onChange={handleChange}
                        />
                      </div>


                       <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Comments </label>
                        <input
                          type="text"
                          className="form-control"
                          name=" comments"
                          value={formItems. comments}
                          onChange={handleChange}
                        />
                      </div>


                       <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                    <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                    <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                  </div>

        </div>

      </div>
                    </form>
            )}


            </div>
    </div>

        </>
    )
}

export default Assets
